export default __webpack_public_path__ + "img/dpElceLJ.47064152.svg";